/**
 * Widget data adapter for `@aimsos/ui`'s WidgetGrid (CT-5273).
 *
 * Signature fixed by the package:
 * `(instanceUuid, scopeContext, dashboardContext, widgetContext?, options?)`.
 *
 * `scopeContext` is what makes the Overview show THIS record's numbers rather
 * than the type's — it carries the entity id down to every widget. Dropping it
 * is the failure mode this adapter exists to prevent, so it goes into the
 * request body explicitly.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

/** TODO(CT-5273 / backend): `POST /v1/workspace/profiles/widgets/data`. */
export const fetchWidgetData = async (
  instanceUuid,
  scopeContext,
  dashboardContext,
  widgetContext = null,
  options = {},
) => {
  options.signal?.throwIfAborted?.();
  const response = await request('/v0/profile/widgets/data', {
    instance_uuid: instanceUuid,
    scope_context: scopeContext ?? null,
    dashboard_context: dashboardContext ?? null,
    widget_context: widgetContext,
  });
  const { body, meta } = validateApiResponse(response, 'Failed to load widget data');
  return { data: body, meta };
};
